import types from './types'

export default {
  [types.SET_AFFECTED_USER](state, affectedUserData) {
    state.affectedUserData = affectedUserData;
  },
  [types.SET_SEARCH_CRITERIA_USER](state, payload) {
    state.payload = payload;
  },
}
